<form [formGroup]="customerDetailsFormGroup" id="step-customer-details" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-0 overflow-visible">
    <div class="row">
      <div class="field-wr flex flex-col col-12 mt-2">
        <div class="row">
          <div class="col-12">
            <h3 data-testid="customer-details" class="border-b pb-3">{{ 'SALE_CREATE.CUSTOMER_DETAILS' | translate }}</h3>
          </div>

          @if (canAssignCustomer) {
            <div class="mb-4 flex items-center gap-1">
              <p-checkbox data-testid="assign-customer" binary="true" formControlName="assignSaleToCustomer" inputId="assignSaleToCustomer" />
              <label for="assignSaleToCustomer">{{ 'SALE_CREATE.ASSIGN_SALE_TO_A_CUSTOMER' | translate }}</label>
            </div>
          }
          @if (!canAssignCustomer) {
            <div>
              <p data-testid="customer-text">{{ 'SALE_CREATE.CUSTOMER_NOT_AVAILABLE' | translate }}
                <tooltip-info data-testid="customer-text-tooltip" [tooltipText]="'SALE_CREATE.CUSTOMER_NOT_AVAILABLE_TOOLTIP' | translate"></tooltip-info>
              </p>
            </div>
          }

          @if (canAssignCustomer && assignSaleToCustomer) {
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-12 col-xl-4">
              <label class="block text-sm">{{ 'SALE_CREATE.CUSTOMER_TYPE' | translate }}</label>
              <div class="flex flex-wrap gap-4">
                <label data-testid="customer-type-old-label" class="inline-flex mr-6">
                  <p-radioButton data-testid="customer-type-old" name="customerType" value="old" formControlName="customerType" inputId="customer-type-old" />
                  <span for="customer-type-old" class="ml-2">{{ 'SALE_CREATE.OPTION_EXISTING_CUSTOMER' | translate }}</span>
                </label>
                <label data-testid="customer-type-new-label" class="inline-flex mr-2">
                  <p-radioButton data-testid="customer-type-new" name="customerType" value="new" formControlName="customerType" inputId="customer-type-new" />
                  <span for="customer-type-new" class="ml-2">{{ 'SALE_CREATE.OPTION_NEW_CUSTOMER' | translate }}</span>
                </label>
              </div>
            </div>
            <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4"
              [ngClass]="{'disabled': customerDetailsFormGroup.get('customerType')?.value === 'new'}">
              <label data-testid="select-customer-label" class="block text-sm" for="customer">{{ 'SALE_CREATE.SELECT_EXISTING_CUSTOMER' | translate }}</label>
              <app-custom-dropdown
                data-testid="customer"
                [placeholder]="'SALE_CREATE.SELECT_CUSTOMER_PLACEHOLDER' | translate"
                optionLabel="text"
                optionValue="id"
                [isMultiselect]="false"
                [showSelectionChips]="true"
                [showClear]="true"
                [searchMode]="'remote'"
                [pageSize]="comboData.rowsPerPageOption || 5"
                [totalCount]="comboData.totalRecords"
                [totalPages]="getComboTotalPages()"
                [options]="comboData.list"
                formControlName="customerId"
                (onLazyLoad)="onLazyLoadComboData($event)">
              </app-custom-dropdown>
            </div>
          }
        </div>
        @if (assignSaleToCustomer) {
          @if (customerDetailsFormGroup.get('customerType')?.value === 'new') {
            <div class="row mt-3">
              <div class="col-12">
                <h3 class="border-b pb-3">{{ 'SALE_CREATE.NEW_CUSTOMER_DETAILS' | translate }}</h3>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-firstname" class="block text-sm" for="firstname">{{ 'CREATE_CUSTOMER.FIRST_NAME' | translate }} <i class="icon-required-field"></i></label>
                <input data-testid="add-customer-firstname-input" type="text" formControlName="firstname" autocomplete="off">
                @if (customerDetailsFormGroup.get('firstname')?.invalid && customerDetailsFormGroup.get('firstname')?.touched) {
                  @if (!customerDetailsFormGroup.get('firstname')?.errors?.['invalidCharacters']) {
                    <small data-testid="add-customer-firstname-mandatory" class="p-error">{{
                    'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-firstnameromanised" class="block text-sm" for="romanisedFirstName">{{ 'CREATE_CUSTOMER.ROMANIZED_FIRST_NAME' | translate }} </label>
                <input data-testid="add-guest-firstnameromanised-input" type="text" formControlName="romanisedFirstName" autocomplete="off">
                @if (customerDetailsFormGroup.get('romanisedFirstName')?.invalid && customerDetailsFormGroup.get('romanisedFirstName')?.touched) {
                  @if (customerDetailsFormGroup.get('romanisedFirstName')?.errors?.['invalidCharacters']) {
                    <small data-testid="add-customer-romanisedfirstname-error"  class="p-error">
                      {{ 'CUSTOMER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                    </small>
                  }
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-lastname" class="block text-sm" for="lastname">{{ 'CREATE_CUSTOMER.LAST_NAME' | translate }} <i class="icon-required-field"></i></label>
                <input data-testid="add-customer-lastname-input" type="text" formControlName="lastname" autocomplete="off">
                @if (customerDetailsFormGroup.get('lastname')?.invalid && customerDetailsFormGroup.get('lastname')?.touched) {
                  @if (!customerDetailsFormGroup.get('lastname')?.errors?.['invalidCharacters']) {
                    <small data-testid="add-customer-lastname-mandatory" class="p-error">{{
                    'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-romanisedlastname" class="block text-sm" for="romanisedLastName">{{ 'CREATE_CUSTOMER.ROMANIZED_LAST_NAME' | translate }} </label>
                <input data-testid="add-customer-romanisedlastname-input" type="text" formControlName="romanisedLastName" autocomplete="off">
                @if (customerDetailsFormGroup.get('romanisedLastName')?.invalid && customerDetailsFormGroup.get('romanisedLastName')?.touched) {
                  @if (customerDetailsFormGroup.get('romanisedLastName')?.errors?.['invalidCharacters']) {
                    <small data-testid="add-customer-romanisedlastname-error" class="p-error">
                      {{ 'CUSTOMER_CREATE.FORMAT_LATIN_CHARSET_ONLY_ALLOWED' | translate }}
                    </small>
                  }
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-email" for="email" class="block text-sm">{{ 'CREATE_CUSTOMER.EMAIL' | translate }} <i
                class="icon-required-field"></i></label>
                <input data-testid="add-customer-email-input" name="email" type="email" autocomplete="off" formControlName="email" class="text-field">
                @if (customerDetailsFormGroup.get('email')?.invalid && (customerDetailsFormGroup.get('email')?.dirty || customerDetailsFormGroup.get('email')?.touched)) {
                  @if (customerDetailsFormGroup.get('email')?.hasError('required')) {
                    <small data-testid="add-customer-email-invalid-error" class="p-error">{{
                      'YOUR_ACCOUNT.VALIDATE_EMAIL'
                    | translate }}</small>
                  }
                  @if (customerDetailsFormGroup.get('email')?.errors?.['invalidEmail']) {
                    <small data-testid="add-customer-email-syntax-error" class="p-error">{{
                    'YOUR_ACCOUNT.VALIDATE_EMAIL_SYNTAX' | translate }}</small>
                  }
                }
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-country" class="block text-sm" for="country">{{ 'CREATE_CUSTOMER.COUNTRY' | translate }}</label>
                <app-custom-dropdown
                  data-testid="add-customer-country-input"
                  [options]="countries"
                  optionLabel="name"
                  optionValue="alpha2"
                  [isMultiselect]="false"
                  [showSelectionChips]="true"
                  [showSearchbox]="true"
                  [showClear]="true"
                  [searchMode]="'local'"
                  [pageSize]="10"
                  [placeholder]="'CREATE_CUSTOMER.COUNTRY' | translate"
                  formControlName="country">
                </app-custom-dropdown>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-address-country" class="block text-sm" for="address">{{ 'CREATE_CUSTOMER.ADDRESS' | translate }}</label>
                <div class="mt-2">
                  <input data-testid="add-customer-address-input" name="address" type="text" autocomplete="address" formControlName="address"
                    autocomplete="off">
                </div>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-postalcode" class="block text-sm" for="postalCode">{{ 'CREATE_CUSTOMER.ZIP_CODE' | translate }}</label>
                <input data-testid="add-customer-postalcode-input" type="text" id="postalCode" formControlName="postalCode" autocomplete="off">
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-birthdate" class="block text-sm" for="birthdate">{{ 'CREATE_CUSTOMER.BIRTHDATE' | translate }}</label>
                <div class="mt-2">
                  <p-datepicker data-testid="add-customer-birthdate-input" formControlName="birthDate" dateFormat="dd-mm-yy" [maxDate]="currentDate"
                    placeholder="{{ 'MODALBOXES.BIRTHDATE_PLACEHOLDER' | translate }}" showIcon="true" appendTo="body"
                    inputId="birthdate" />
                </div>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <label data-testid="add-customer-field-gender" for="gender">{{ 'CREATE_CUSTOMER.GENDER' | translate }}</label>
                <app-custom-dropdown
                  data-testid="selector-input-gender"
                  [options]="genders"
                  optionLabel="label"
                  optionValue="value"
                  [isMultiselect]="false"
                  [showSelectionChips]="true"
                  [showSearchbox]="false"
                  [showClear]="true"
                  [searchMode]="'local'"
                  [pageSize]="10"
                  [placeholder]="'CREATE_CUSTOMER.SELECT_GENDER_PLACEHOLDER' | translate"
                  formControlName="gender">
                </app-custom-dropdown>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3 mt-auto">
                <div class="flex items-center gap-2">
                  <p-checkbox data-testid="add-customer-foreign-input" formControlName="foreign" inputId="foreign" binary="true" />
                  <label for="foreign">{{ 'CUSTOMER_CREATE.FOREIGN_CUSTOMER' | translate }}</label>
                </div>
              </div>
              <!-- <div class="row">
              <div class="flex flex-col col-12 mb-4">
                <h2 class="border-b pb-3">{{ 'CUSTOMER_SINGLE_VIEW.BRAND_INFORMATION' | translate }}</h2>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 mt-auto">
                <div class="flex flex-row">
                  <p-checkbox data-testid="add-customer-wantemails-input" formControlName="wantEmails" inputId="wantEmails"
                    binary="true">
                  </p-checkbox>
                  <label for="wantEmails" class="ml-2">
                    {{ 'CUSTOMER_CREATE.WANT_EMAILS_PREFIX' | translate }}
                    @if (companyLinks.brandPrivacy) {
                      <a [href]="companyLinks.brandPrivacy" target="_blank" rel="noopener noreferrer" class="link">
                        {{ 'CUSTOMER_CREATE.BRAND_PRIVACY_POLICY' | translate }}
                      </a>
                    } @else {
                      {{ 'CUSTOMER_CREATE.BRAND_PRIVACY_POLICY' | translate }}
                    }
                  </label>
                </div>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 mt-auto pt-2">
                <div class="flex flex-row">
                  <p-checkbox data-testid="add-customer-acceptterms-input" formControlName="acceptedTerms" inputId="acceptedTerms"binary="true">
                  </p-checkbox>
                  <label for="acceptedTerms" class="ml-2">{{ 'CUSTOMER_CREATE.TOS_ACCEPTED_PREFIX' | translate }}
                  @if (companyLinks.brandTerms) {
                    <a [href]="companyLinks.brandTerms" target="_blank" rel="noopener noreferrer". class="link">
                      {{ 'CUSTOMER_CREATE.BRAND_TERMS_OF_SERVICE' | translate }}
                    </a>
                  } @else {
                    {{ 'CUSTOMER_CREATE.BRAND_TERMS_OF_SERVICE' | translate }}
                  }
                  </label>
                </div>
              </div>
            </div> -->
            <div class="row">
              <div class="flex flex-col col-12 mb-4">
                <h2 class="border-b pb-3">{{ 'CUSTOMER_SINGLE_VIEW.BRAND_INFORMATION' | translate }}</h2>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 pb-1 justify-end">
                <div class="flex flex-row">
                  <p-checkbox data-testid="add-customer-wantemails-input" formControlName="wantEmails" inputId="wantEmails" binary="true" />
                  <label for="wantEmails" class="ml-2">
                    {{ 'CUSTOMER_CREATE.WANT_EMAILS_PREFIX' | translate }}
                    <a>{{ 'CUSTOMER_CREATE.WANT_EMAILS_COMMUNICATIONS' | translate }}</a>
                  </label>
                </div>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pb-1 justify-end">
                <div class="flex flex-row">
                  <p-checkbox data-testid="add-customer-acceptedPrivacyPolicy-input" formControlName="acceptedPrivacyPolicy" inputId="acceptedPrivacyPolicy" binary="true" />
                  <label for="acceptedPrivacyPolicy" class="ml-2">
                    {{ 'CUSTOMER_CREATE.WANT_EMAILS_PREFIX' | translate }}
                    @if (companyLinks.brandPrivacy) {
                      <a [href]="companyLinks.brandPrivacy" target="_blank" rel="noopener noreferrer"class="link">
                        {{ 'CUSTOMER_CREATE.BRAND_PRIVACY_POLICY' | translate }}
                      </a>
                    } @else {
                      {{ 'CUSTOMER_CREATE.BRAND_PRIVACY_POLICY' | translate }}
                    }
                  </label>
                </div>
              </div>
              <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 pb-1 justify-end mt-4">
                <div class="flex flex-row">
                  <p-checkbox data-testid="add-customer-acceptterms-input" formControlName="acceptedTerms"inputId="acceptedTerms" binary="true" />
                  <label for="acceptedTerms" class="ml-2">
                    {{ 'CUSTOMER_CREATE.TOS_ACCEPTED_PREFIX' | translate }}
                    @if (companyLinks.brandTerms) {
                      <a [href]="companyLinks.brandTerms" target="_blank" rel="noopener noreferrer" class="link">{{ 'CUSTOMER_CREATE.BRAND_TERMS_OF_SERVICE' | translate }}</a>
                    } @else {
                      {{ 'CUSTOMER_CREATE.BRAND_TERMS_OF_SERVICE' | translate }}
                    }
                  </label>
                </div>
              </div>
            </div>
          </div>
        }
      }
    </div>
  </div>

  <div class="row mt-3 mb-4">
    <div class="field-wr flex flex-col col-12 col-md-2 mt-auto">
      <button data-testid="add-customer-btn" class="btn primary-btn" [disabled]="customerDetailsFormGroup.get('assignSaleToCustomer')?.value && customerDetailsFormGroup.invalid" (click)="onSaveStepData()">{{ 'SALE_CREATE.BTN_NEXT_STEP' | translate }}</button>
    </div>
  </div>
</div>
</form>
